import React from "react";

const ComingSoon = () => {
  return (
    <React.Fragment>
      <section className="min-h-[calc(100vh-134px)] flex items-center justify-center">
        <div className="max-w-[1440px] mx-auto text-center px-4">
          <div className="space-y-5">
            <p className="text-lg dark:text-white/80">
              <span className="w-6 relative -top-1.5 h-[2px] inline-block bg-black dark:bg-white/80"></span>{" "}
              Coming Soon
            </p>
            <h2 className="text-3xl font-bold md:text-5xl dark:text-white">
              Get Notified When We Launch
            </h2>
            <div className="relative max-w-[400px] mx-auto !mt-10">
              <input
                type="email"
                id="search"
                className="form-input ltr:pr-[126px] rtl:pl-[126px]"
                placeholder="Search..."
                required
              />
              <button
                type="button"
                className="absolute inset-y-1 ltr:right-1 rtl:left-1 btn bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                style={{right: "0.25rem"}}
              >
                Notify Me!
              </button>
            </div>
            <p className="text-lg !mt-10 dark:text-darkmuted">
              *Don't worry we will not spam you :)
            </p>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ComingSoon;
